import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import PasskeysSettings from './components/PasskeysSettings';
import PasskeySignUpButton from './components/PasskeySignUpButton';
import { decodeRequestOptions, serializeAssertionCredential, isUserCancellation } from './utils/webauthn';
export { default as extend } from './extend';
async function loginWithPasskey() {
  if (!app.forum.attribute('passkeysEnabled')) return;
  try {
    const response = await app.request({
      method: 'POST',
      url: app.forum.attribute('baseUrl') + '/passkeys/login/options',
      errorHandler: () => {}
    });
    const publicKey = decodeRequestOptions(response.publicKey);
    const credential = await navigator.credentials.get({
      publicKey
    });
    if (!credential) {
      return;
    }
    await app.request({
      method: 'POST',
      url: app.forum.attribute('baseUrl') + '/passkeys/login/verify',
      body: {
        credential: serializeAssertionCredential(credential)
      },
      errorHandler: () => {}
    });
    window.location.reload();
  } catch (error) {
    if (!isUserCancellation(error)) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('cengizkemec-passkeys.forum.log_in.passkey_error'));
    }
  }
}
app.initializers.add('cengizkemec-passkeys', () => {
  extend('flarum/forum/components/LogInButtons', 'items', function (items) {
    if (!app.forum.attribute('passkeysEnabled')) return;
    items.add('passkey', m(Button, {
      className: "Button LogInButton LogInButton--passkey",
      icon: "fas fa-key",
      onclick: () => loginWithPasskey()
    }, app.translator.trans('cengizkemec-passkeys.forum.log_in.with_passkey')), -10);
  });
  extend('flarum/forum/components/SettingsPage', 'accountItems', function (items) {
    if (!app.session.user || !app.forum.attribute('passkeysEnabled')) return;
    items.add('passkeys', m(PasskeysSettings, null), 50);
  });
  extend('flarum/forum/components/SignUpModal', 'fields', function (items) {
    if (!app.forum.attribute('passkeysEnabled') || !app.forum.attribute('passkeysSignupEnabled') || !app.forum.attribute('allowSignUp') || this.attrs.token) {
      return;
    }
    items.add('passkey-signup', m(PasskeySignUpButton, {
      modal: this
    }), 5);
  });
});